import React from 'react';
import PropTypes from 'prop-types';
import Select from '@/modules/common/components/Select';
import TextField from '@/modules/common/components/TextField';

const optionsExt = [{
    title: 'XML', value: 'xml',
}];

const Form = (props) => {
    return (
        <>
            <TextField label="Название"
                       value={props.values.name} onChange={props.onChange('name')}
                       error={props.errors.name.length > 0}
                       helperText={props.errors.name}
                       onFocus={props.onFocus('name')}
                       autoFocus={true}
            />
            <Select label="Расширение" options={optionsExt}
                    value={props.values.ext} onChange={props.onChange('ext')}
                    error={props.errors.ext.length > 0}
                    helperText={props.errors.ext}
                    onFocus={props.onFocus('ext')}
            />
            <TextField label="Данные" multiline={true}
                       value={props.values.data} onChange={props.onChange('data')}
                       error={props.errors.data.length > 0}
                       helperText={props.errors.data}
                       onFocus={props.onFocus('data')}
            />
        </>
    );
};

Form.propTypes = {
    values: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    onFocus: PropTypes.func.isRequired,
};

export default Form;
